/**
 * Zippee fast-delivery pincode map - generated from "Zippee SDD Pincodes.xlsx".
 *
 *   pincode -> [city, darkStore]
 *
 * ONLY THE CITIES LISTED HERE ARE LIVE. A pincode absent from this map gets standard
 * delivery with no call to the stock service at all, so this file is the switch that
 * decides where fast delivery is offered.
 *
 * Sober went live in MUMBAI ONLY on 2026-10-13. Delhi NCR and Bengaluru are commented
 * out at the bottom: Zippee holds zero stock in both, and leaving them active meant the
 * landing-page popup promised same-day to those cities - it answers from this map alone
 * and never checks stock, so an empty warehouse still read as "Same-day delivery".
 *
 * TO SWITCH A CITY ON: uncomment its block and paste the entries above the closing
 * brace. Nothing else needs changing - the backend already maps all three cities to
 * their Zippee location keys, and the theme settings carry on working.
 *
 * NOTE: the source sheet does not distinguish same-day from next-day - it is one flat
 * list per city. Until Zippee supply that split, every listed pincode is treated the
 * same and the service level comes from SBR_FAST_SERVICE below.
 */
window.SBR_FAST_SERVICE = 'same-day' // 'same-day' | 'next-day'

/* ----------------------------------------------------------------- LIVE CITIES */

window.SBR_FAST_PINCODES = {
  "400001": ["Mumbai", "Andheri East"],
  "400002": ["Mumbai", "Andheri East"],
  "400003": ["Mumbai", "Andheri East"],
  "400004": ["Mumbai", "Andheri East"],
  "400005": ["Mumbai", "Andheri East"],
  "400006": ["Mumbai", "Andheri East"],
  "400007": ["Mumbai", "Andheri East"],
  "400008": ["Mumbai", "Andheri East"],
  "400009": ["Mumbai", "Andheri East"],
  "400010": ["Mumbai", "Andheri East"],
  "400011": ["Mumbai", "Andheri East"],
  "400012": ["Mumbai", "Andheri East"],
  "400013": ["Mumbai", "Andheri East"],
  "400014": ["Mumbai", "Andheri East"],
  "400015": ["Mumbai", "Andheri East"],
  "400016": ["Mumbai", "Andheri East"],
  "400017": ["Mumbai", "Andheri East"],
  "400018": ["Mumbai", "Andheri East"],
  "400019": ["Mumbai", "Andheri East"],
  "400020": ["Mumbai", "Andheri East"],
  "400021": ["Mumbai", "Andheri East"],
  "400022": ["Mumbai", "Andheri East"],
  "400023": ["Mumbai", "Andheri East"],
  "400024": ["Mumbai", "Andheri East"],
  "400025": ["Mumbai", "Andheri East"],
  "400026": ["Mumbai", "Andheri East"],
  "400027": ["Mumbai", "Andheri East"],
  "400028": ["Mumbai", "Andheri East"],
  "400029": ["Mumbai", "Andheri East"],
  "400030": ["Mumbai", "Andheri East"],
  "400031": ["Mumbai", "Andheri East"],
  "400032": ["Mumbai", "Andheri East"],
  "400033": ["Mumbai", "Andheri East"],
  "400034": ["Mumbai", "Andheri East"],
  "400035": ["Mumbai", "Andheri East"],
  "400036": ["Mumbai", "Andheri East"],
  "400037": ["Mumbai", "Andheri East"],
  "400039": ["Mumbai", "Andheri East"],
  "400042": ["Mumbai", "Andheri East"],
  "400043": ["Mumbai", "Andheri East"],
  "400047": ["Mumbai", "Andheri East"],
  "400049": ["Mumbai", "Andheri East"],
  "400050": ["Mumbai", "Andheri East"],
  "400051": ["Mumbai", "Andheri East"],
  "400052": ["Mumbai", "Andheri East"],
  "400053": ["Mumbai", "Andheri East"],
  "400054": ["Mumbai", "Andheri East"],
  "400055": ["Mumbai", "Andheri East"],
  "400056": ["Mumbai", "Andheri East"],
  "400057": ["Mumbai", "Andheri East"],
  "400058": ["Mumbai", "Andheri East"],
  "400059": ["Mumbai", "Andheri East"],
  "400060": ["Mumbai", "Andheri East"],
  "400061": ["Mumbai", "Andheri East"],
  "400062": ["Mumbai", "Andheri East"],
  "400063": ["Mumbai", "Andheri East"],
  "400064": ["Mumbai", "Andheri East"],
  "400065": ["Mumbai", "Andheri East"],
  "400066": ["Mumbai", "Andheri East"],
  "400067": ["Mumbai", "Andheri East"],
  "400068": ["Mumbai", "Andheri East"],
  "400069": ["Mumbai", "Andheri East"],
  "400070": ["Mumbai", "Andheri East"],
  "400071": ["Mumbai", "Andheri East"],
  "400072": ["Mumbai", "Andheri East"],
  "400074": ["Mumbai", "Andheri East"],
  "400075": ["Mumbai", "Andheri East"],
  "400076": ["Mumbai", "Andheri East"],
  "400077": ["Mumbai", "Andheri East"],
  "400078": ["Mumbai", "Andheri East"],
  "400079": ["Mumbai", "Andheri East"],
  "400080": ["Mumbai", "Andheri East"],
  "400081": ["Mumbai", "Andheri East"],
  "400082": ["Mumbai", "Andheri East"],
  "400083": ["Mumbai", "Andheri East"],
  "400084": ["Mumbai", "Andheri East"],
  "400085": ["Mumbai", "Andheri East"],
  "400086": ["Mumbai", "Andheri East"],
  "400087": ["Mumbai", "Andheri East"],
  "400088": ["Mumbai", "Andheri East"],
  "400089": ["Mumbai", "Andheri East"],
  "400091": ["Mumbai", "Andheri East"],
  "400092": ["Mumbai", "Andheri East"],
  "400093": ["Mumbai", "Andheri East"],
  "400094": ["Mumbai", "Andheri East"],
  "400095": ["Mumbai", "Andheri East"],
  "400096": ["Mumbai", "Andheri East"],
  "400097": ["Mumbai", "Andheri East"],
  "400098": ["Mumbai", "Andheri East"],
  "400099": ["Mumbai", "Andheri East"],
  "400101": ["Mumbai", "Andheri East"],
  "400102": ["Mumbai", "Andheri East"],
  "400103": ["Mumbai", "Andheri East"],
  "400104": ["Mumbai", "Andheri East"],
  "400601": ["Mumbai", "Andheri East"],
  "400606": ["Mumbai", "Andheri East"],
  "400607": ["Mumbai", "Andheri East"],
  "400608": ["Mumbai", "Andheri East"],
  "400615": ["Mumbai", "Andheri East"],
  "401101": ["Mumbai", "Andheri East"],
  "401105": ["Mumbai", "Andheri East"],
  "401106": ["Mumbai", "Andheri East"],
  "401107": ["Mumbai", "Andheri East"]
}

/* -------------------------------------------------------------- DORMANT CITIES
 *
 * Not live. Zippee has no stock in either location as of 2026-10-13. Kept verbatim so
 * switching a city on is a copy-paste rather than a regenerate - though the source
 * sheet is still at "Zippee SDD Pincodes.xlsx" in the project root if these are ever
 * lost or need refreshing.
 *
 * ---- Delhi NCR (132 pincodes) ----
 *
 *   "110001": ["Delhi NCR", "Okhla"],
 *   "110002": ["Delhi NCR", "Okhla"],
 *   "110003": ["Delhi NCR", "Okhla"],
 *   "110004": ["Delhi NCR", "Okhla"],
 *   "110005": ["Delhi NCR", "Okhla"],
 *   "110006": ["Delhi NCR", "Okhla"],
 *   "110007": ["Delhi NCR", "Okhla"],
 *   "110008": ["Delhi NCR", "Okhla"],
 *   "110009": ["Delhi NCR", "Okhla"],
 *   "110010": ["Delhi NCR", "Okhla"],
 *   "110011": ["Delhi NCR", "Okhla"],
 *   "110012": ["Delhi NCR", "Okhla"],
 *   "110013": ["Delhi NCR", "Okhla"],
 *   "110014": ["Delhi NCR", "Okhla"],
 *   "110015": ["Delhi NCR", "Okhla"],
 *   "110016": ["Delhi NCR", "Okhla"],
 *   "110017": ["Delhi NCR", "Okhla"],
 *   "110018": ["Delhi NCR", "Okhla"],
 *   "110019": ["Delhi NCR", "Okhla"],
 *   "110020": ["Delhi NCR", "Okhla"],
 *   "110021": ["Delhi NCR", "Okhla"],
 *   "110022": ["Delhi NCR", "Okhla"],
 *   "110023": ["Delhi NCR", "Okhla"],
 *   "110024": ["Delhi NCR", "Okhla"],
 *   "110025": ["Delhi NCR", "Okhla"],
 *   "110026": ["Delhi NCR", "Okhla"],
 *   "110027": ["Delhi NCR", "Okhla"],
 *   "110028": ["Delhi NCR", "Okhla"],
 *   "110029": ["Delhi NCR", "Okhla"],
 *   "110030": ["Delhi NCR", "Okhla"],
 *   "110031": ["Delhi NCR", "Okhla"],
 *   "110032": ["Delhi NCR", "Okhla"],
 *   "110033": ["Delhi NCR", "Okhla"],
 *   "110034": ["Delhi NCR", "Okhla"],
 *   "110035": ["Delhi NCR", "Okhla"],
 *   "110037": ["Delhi NCR", "Okhla"],
 *   "110044": ["Delhi NCR", "Okhla"],
 *   "110045": ["Delhi NCR", "Okhla"],
 *   "110046": ["Delhi NCR", "Okhla"],
 *   "110047": ["Delhi NCR", "Okhla"],
 *   "110048": ["Delhi NCR", "Okhla"],
 *   "110049": ["Delhi NCR", "Okhla"],
 *   "110051": ["Delhi NCR", "Okhla"],
 *   "110052": ["Delhi NCR", "Okhla"],
 *   "110053": ["Delhi NCR", "Okhla"],
 *   "110054": ["Delhi NCR", "Okhla"],
 *   "110055": ["Delhi NCR", "Okhla"],
 *   "110056": ["Delhi NCR", "Okhla"],
 *   "110057": ["Delhi NCR", "Okhla"],
 *   "110058": ["Delhi NCR", "Okhla"],
 *   "110059": ["Delhi NCR", "Okhla"],
 *   "110060": ["Delhi NCR", "Okhla"],
 *   "110062": ["Delhi NCR", "Okhla"],
 *   "110063": ["Delhi NCR", "Okhla"],
 *   "110064": ["Delhi NCR", "Okhla"],
 *   "110065": ["Delhi NCR", "Okhla"],
 *   "110066": ["Delhi NCR", "Okhla"],
 *   "110067": ["Delhi NCR", "Okhla"],
 *   "110068": ["Delhi NCR", "Okhla"],
 *   "110069": ["Delhi NCR", "Okhla"],
 *   "110070": ["Delhi NCR", "Okhla"],
 *   "110074": ["Delhi NCR", "Okhla"],
 *   "110075": ["Delhi NCR", "Okhla"],
 *   "110076": ["Delhi NCR", "Okhla"],
 *   "110077": ["Delhi NCR", "Okhla"],
 *   "110078": ["Delhi NCR", "Okhla"],
 *   "110079": ["Delhi NCR", "Okhla"],
 *   "110080": ["Delhi NCR", "Okhla"],
 *   "110083": ["Delhi NCR", "Okhla"],
 *   "110084": ["Delhi NCR", "Okhla"],
 *   "110085": ["Delhi NCR", "Okhla"],
 *   "110086": ["Delhi NCR", "Okhla"],
 *   "110087": ["Delhi NCR", "Okhla"],
 *   "110088": ["Delhi NCR", "Okhla"],
 *   "110089": ["Delhi NCR", "Okhla"],
 *   "110090": ["Delhi NCR", "Okhla"],
 *   "110091": ["Delhi NCR", "Okhla"],
 *   "110092": ["Delhi NCR", "Okhla"],
 *   "110093": ["Delhi NCR", "Okhla"],
 *   "110094": ["Delhi NCR", "Okhla"],
 *   "110095": ["Delhi NCR", "Okhla"],
 *   "110096": ["Delhi NCR", "Okhla"],
 *   "110097": ["Delhi NCR", "Okhla"],
 *   "110099": ["Delhi NCR", "Okhla"],
 *   "121001": ["Delhi NCR", "Okhla"],
 *   "121002": ["Delhi NCR", "Okhla"],
 *   "121003": ["Delhi NCR", "Okhla"],
 *   "121005": ["Delhi NCR", "Okhla"],
 *   "121006": ["Delhi NCR", "Okhla"],
 *   "121007": ["Delhi NCR", "Okhla"],
 *   "121008": ["Delhi NCR", "Okhla"],
 *   "121009": ["Delhi NCR", "Okhla"],
 *   "121010": ["Delhi NCR", "Okhla"],
 *   "121012": ["Delhi NCR", "Okhla"],
 *   "121013": ["Delhi NCR", "Okhla"],
 *   "121101": ["Delhi NCR", "Okhla"],
 *   "122001": ["Delhi NCR", "Okhla"],
 *   "122002": ["Delhi NCR", "Okhla"],
 *   "122003": ["Delhi NCR", "Okhla"],
 *   "122005": ["Delhi NCR", "Okhla"],
 *   "122007": ["Delhi NCR", "Okhla"],
 *   "122008": ["Delhi NCR", "Okhla"],
 *   "122009": ["Delhi NCR", "Okhla"],
 *   "122010": ["Delhi NCR", "Okhla"],
 *   "122011": ["Delhi NCR", "Okhla"],
 *   "122015": ["Delhi NCR", "Okhla"],
 *   "122016": ["Delhi NCR", "Okhla"],
 *   "122017": ["Delhi NCR", "Okhla"],
 *   "122018": ["Delhi NCR", "Okhla"],
 *   "122021": ["Delhi NCR", "Okhla"],
 *   "122022": ["Delhi NCR", "Okhla"],
 *   "201004": ["Delhi NCR", "Okhla"],
 *   "201005": ["Delhi NCR", "Okhla"],
 *   "201006": ["Delhi NCR", "Okhla"],
 *   "201007": ["Delhi NCR", "Okhla"],
 *   "201009": ["Delhi NCR", "Okhla"],
 *   "201010": ["Delhi NCR", "Okhla"],
 *   "201011": ["Delhi NCR", "Okhla"],
 *   "201012": ["Delhi NCR", "Okhla"],
 *   "201014": ["Delhi NCR", "Okhla"],
 *   "201016": ["Delhi NCR", "Okhla"],
 *   "201017": ["Delhi NCR", "Okhla"],
 *   "201103": ["Delhi NCR", "Okhla"],
 *   "201301": ["Delhi NCR", "Okhla"],
 *   "201303": ["Delhi NCR", "Okhla"],
 *   "201304": ["Delhi NCR", "Okhla"],
 *   "201305": ["Delhi NCR", "Okhla"],
 *   "201306": ["Delhi NCR", "Okhla"],
 *   "201307": ["Delhi NCR", "Okhla"],
 *   "201309": ["Delhi NCR", "Okhla"],
 *   "201310": ["Delhi NCR", "Okhla"],
 *   "201313": ["Delhi NCR", "Okhla"],
 *
 * ---- Bengaluru (105 pincodes) ----
 *
 *   "560001": ["Bengaluru", "Kalyan Nagar"],
 *   "560002": ["Bengaluru", "Koramangala"],
 *   "560003": ["Bengaluru", "Kalyan Nagar"],
 *   "560004": ["Bengaluru", "Koramangala"],
 *   "560005": ["Bengaluru", "Kalyan Nagar"],
 *   "560006": ["Bengaluru", "Kalyan Nagar"],
 *   "560007": ["Bengaluru", "Koramangala"],
 *   "560008": ["Bengaluru", "Kalyan Nagar"],
 *   "560009": ["Bengaluru", "Kalyan Nagar"],
 *   "560010": ["Bengaluru", "Kalyan Nagar"],
 *   "560011": ["Bengaluru", "Koramangala"],
 *   "560012": ["Bengaluru", "Kalyan Nagar"],
 *   "560013": ["Bengaluru", "Kalyan Nagar"],
 *   "560014": ["Bengaluru", "Kalyan Nagar"],
 *   "560015": ["Bengaluru", "Kalyan Nagar"],
 *   "560016": ["Bengaluru", "Kalyan Nagar"],
 *   "560017": ["Bengaluru", "Koramangala"],
 *   "560018": ["Bengaluru", "Koramangala"],
 *   "560019": ["Bengaluru", "Koramangala"],
 *   "560020": ["Bengaluru", "Kalyan Nagar"],
 *   "560021": ["Bengaluru", "Kalyan Nagar"],
 *   "560022": ["Bengaluru", "Kalyan Nagar"],
 *   "560023": ["Bengaluru", "Kalyan Nagar"],
 *   "560024": ["Bengaluru", "Kalyan Nagar"],
 *   "560025": ["Bengaluru", "Koramangala"],
 *   "560026": ["Bengaluru", "Koramangala"],
 *   "560027": ["Bengaluru", "Koramangala"],
 *   "560028": ["Bengaluru", "Koramangala"],
 *   "560029": ["Bengaluru", "Koramangala"],
 *   "560030": ["Bengaluru", "Koramangala"],
 *   "560031": ["Bengaluru", "Koramangala"],
 *   "560032": ["Bengaluru", "Kalyan Nagar"],
 *   "560033": ["Bengaluru", "Kalyan Nagar"],
 *   "560034": ["Bengaluru", "Koramangala"],
 *   "560035": ["Bengaluru", "Koramangala"],
 *   "560036": ["Bengaluru", "Kalyan Nagar"],
 *   "560037": ["Bengaluru", "Koramangala"],
 *   "560038": ["Bengaluru", "Kalyan Nagar"],
 *   "560039": ["Bengaluru", "Koramangala"],
 *   "560040": ["Bengaluru", "Koramangala"],
 *   "560041": ["Bengaluru", "Koramangala"],
 *   "560042": ["Bengaluru", "Kalyan Nagar"],
 *   "560043": ["Bengaluru", "Kalyan Nagar"],
 *   "560044": ["Bengaluru", "Koramangala"],
 *   "560045": ["Bengaluru", "Kalyan Nagar"],
 *   "560046": ["Bengaluru", "Kalyan Nagar"],
 *   "560047": ["Bengaluru", "Koramangala"],
 *   "560048": ["Bengaluru", "Kalyan Nagar"],
 *   "560049": ["Bengaluru", "Kalyan Nagar"],
 *   "560050": ["Bengaluru", "Koramangala"],
 *   "560051": ["Bengaluru", "Kalyan Nagar"],
 *   "560052": ["Bengaluru", "Koramangala"],
 *   "560053": ["Bengaluru", "Kalyan Nagar"],
 *   "560054": ["Bengaluru", "Kalyan Nagar"],
 *   "560055": ["Bengaluru", "Kalyan Nagar"],
 *   "560056": ["Bengaluru", "Koramangala"],
 *   "560057": ["Bengaluru", "Kalyan Nagar"],
 *   "560058": ["Bengaluru", "Kalyan Nagar"],
 *   "560059": ["Bengaluru", "Koramangala"],
 *   "560060": ["Bengaluru", "Koramangala"],
 *   "560061": ["Bengaluru", "Koramangala"],
 *   "560062": ["Bengaluru", "Koramangala"],
 *   "560063": ["Bengaluru", "Kalyan Nagar"],
 *   "560064": ["Bengaluru", "Kalyan Nagar"],
 *   "560065": ["Bengaluru", "Kalyan Nagar"],
 *   "560066": ["Bengaluru", "Koramangala"],
 *   "560067": ["Bengaluru", "Kalyan Nagar"],
 *   "560068": ["Bengaluru", "Koramangala"],
 *   "560069": ["Bengaluru", "Koramangala"],
 *   "560070": ["Bengaluru", "Koramangala"],
 *   "560071": ["Bengaluru", "Koramangala"],
 *   "560072": ["Bengaluru", "Kalyan Nagar"],
 *   "560073": ["Bengaluru", "Kalyan Nagar"],
 *   "560075": ["Bengaluru", "Kalyan Nagar"],
 *   "560076": ["Bengaluru", "Koramangala"],
 *   "560077": ["Bengaluru", "Kalyan Nagar"],
 *   "560078": ["Bengaluru", "Koramangala"],
 *   "560079": ["Bengaluru", "Kalyan Nagar"],
 *   "560080": ["Bengaluru", "Kalyan Nagar"],
 *   "560081": ["Bengaluru", "Koramangala"],
 *   "560083": ["Bengaluru", "Koramangala"],
 *   "560084": ["Bengaluru", "Kalyan Nagar"],
 *   "560085": ["Bengaluru", "Koramangala"],
 *   "560086": ["Bengaluru", "Kalyan Nagar"],
 *   "560087": ["Bengaluru", "Koramangala"],
 *   "560090": ["Bengaluru", "Kalyan Nagar"],
 *   "560091": ["Bengaluru", "Kalyan Nagar"],
 *   "560092": ["Bengaluru", "Kalyan Nagar"],
 *   "560093": ["Bengaluru", "Kalyan Nagar"],
 *   "560094": ["Bengaluru", "Kalyan Nagar"],
 *   "560095": ["Bengaluru", "Koramangala"],
 *   "560096": ["Bengaluru", "Kalyan Nagar"],
 *   "560097": ["Bengaluru", "Kalyan Nagar"],
 *   "560098": ["Bengaluru", "Koramangala"],
 *   "560099": ["Bengaluru", "Koramangala"],
 *   "560100": ["Bengaluru", "Koramangala"],
 *   "560101": ["Bengaluru", "Kalyan Nagar"],
 *   "560102": ["Bengaluru", "Koramangala"],
 *   "560103": ["Bengaluru", "Koramangala"],
 *   "560104": ["Bengaluru", "Koramangala"],
 *   "560107": ["Bengaluru", "Kalyan Nagar"],
 *   "560108": ["Bengaluru", "Koramangala"],
 *   "560109": ["Bengaluru", "Koramangala"],
 *   "560111": ["Bengaluru", "Koramangala"],
 *   "560180": ["Bengaluru", "Koramangala"],
 *
 */
